import React from 'react'

const Alert = (props) => {

    const onClickCross = () => {
        const AlertContainer = document.querySelector('.Alert-container')
        AlertContainer.classList.toggle('d-none')
    }

    return (
        <>{props.alert &&
            <div class="Alert-container" style={{ backgroundColor: props.alert.type }}>
                <p>{props.alert.msg}</p>
                <button onClick={onClickCross} className='Cross-btn' style={{ backgroundColor: props.alert.type }}><i class="fa-solid fa-xmark"></i></button>
            </div>
        }
        </>
    )
}

export default Alert